import styled from 'styled-components/macro'

export const WrapperLabel = styled.label`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
`

export const Header = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 4px;
`

export const LabelText = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: inherit;
`

export const Body = styled.div``

export const Footer = styled.div``
